import { calculateEnvironmentByHost } from '@cian/utils';
import { getStageId } from './getStageId';

/**
 * Функция получения объекта { host + path },
 * для разных окружений SOPR
 */
interface IReturnType {
  apiUrl: string;
  path: string;
}

type TReturnType = IReturnType | null;

export function getSoprApi(path: string): TReturnType {
  /* istanbul ignore if */
  if (typeof window === 'undefined') {
    return null;
  }

  const env = calculateEnvironmentByHost(window.location.host);

  const soprUrlConfig = {
    apiUrl: 'https://sopr-api.cian.ru/',
    path,
  };

  if (env === 'development') {
    return Object.assign(soprUrlConfig, {
      apiUrl: 'http://master.sopr.dev3.cian.ru/',
    });
  }

  if (env === 'beta') {
    const betaId = getStageId(window.location.host);

    return Object.assign(soprUrlConfig, {
      apiUrl: `https://beta${betaId}.sopr.stage.cian.ru/`,
    });
  }

  return soprUrlConfig;
}
